import * as endpoints from './endpoints';

const PatientIntakeService = { ...endpoints };

export default PatientIntakeService;
export type { PatientIntake, ListPatientIntakesOpts } from './endpoints';
